module.exports = __webpack_public_path__ + "static/media/mergemultiplepdf.eeae5987.png";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/apks/mergemultiplepdf.png
// module id = 345
// module chunks = 0